<template>
  <div id="app" v-cloak>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowWidth: 0,
    };
  },
  mounted() {
    this.getWindowWidth();
    window.addEventListener("resize", this.getWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowWidth);
  },
  methods: {
    getWindowWidth() {
      this.windowWidth = window.innerWidth;
      this.$store.commit("SET_WINDOWW", this.windowWidth);
      // console.log();
    },
  },
};
</script>
